import $ from 'jquery';
import ko from 'knockout';
import _ from 'lodash';
import templateMarkup from 'raw-loader!./list-builder-widget.html';

function ListBuilderWidget(params) {
    var self = this;

    activate();

    function activate() {
        initializeVariables();
        setupWidget();
        getData();
        feedData();
        setupExtras();
    }

    function clearUI() {
        _.get(self, ['lb', 'left', 'all'])([]);
        _.get(self, ['lb', 'right', 'all'])([]);
        updateElements();
    }

    function feedData() {
        initializeLists();
        setupExtras();
    }

    function isEnabledProvider(path) {
        return function isEnabled() {
            return !_.isEmpty(ko.unwrap(_.get(this, ['lb'].concat(path))));
        };
    }
    function getCountProvider(path) {
        return function getCount() {
            return _.get(ko.unwrap(_.get(this, ['lb'].concat(path))), 'length', 0);
        };
    }

    function setupExtras() {
        //  'lb' stands for 'list builder' (pseudo namespace)

        //  count badges
        _.set(self, ['lb', 'left', 'total'], ko.computed(getCountProvider(['left', 'all']), self));
        _.set(self, ['lb', 'right', 'total'], ko.computed(getCountProvider(['right', 'all']), self));

        //  toggle buttons' enable/disable attribute
        _.set(self, ['lb', 'add', 'all', 'isEnabled'], ko.computed(isEnabledProvider(['left', 'all']), self));
        _.set(self, ['lb', 'add', 'page', 'isEnabled'], ko.computed(isEnabledProvider(['left', 'page']), self));
        _.set(self, ['lb', 'add', 'selection', 'isEnabled'], ko.computed(isEnabledProvider(['left', 'selection']), self));
        _.set(self, ['lb', 'remove', 'all', 'isEnabled'], ko.computed(isEnabledProvider(['right', 'all']), self));
        _.set(self, ['lb', 'remove', 'page', 'isEnabled'], ko.computed(isEnabledProvider(['right', 'page']), self));
        _.set(self, ['lb', 'remove', 'selection', 'isEnabled'], ko.computed(isEnabledProvider(['right', 'selection']), self));
    }

    function getData() {
        //  TODO: consider a better "wiring" strategy
        self.params.originalAvailableItems.subscribe(function (itemsArrayStream) {
            // console.log("itemsArrayStream @subscribe", itemsArrayStream);
            _.get(self.originalDatasets, 'left')(itemsArrayStream);
            initializeLists();
        });

        self.params.originalSelectedItems.subscribe(function (selectionStream) {
            // console.log("selectionStream @subscribe", selectionStream);
            _.get(self.originalDatasets, 'right')(selectionStream);
            initializeLists();
        });
    }

    function getOptionsReadyArray(datahub, group, action) {
        var optionsBuilderFn;
        var sortingByAttr;

        if (action === 'initialize') {
            optionsBuilderFn = buildOptionsFn;
            sortingByAttr = self.selectOptions.textKey;

        } else { //  action === 'update'
            optionsBuilderFn = updateOptionsFn;
            sortingByAttr = self.selectOptions.containerPathKey + '.' + self.selectOptions.textKey;
        }

        return _.map(_.sortBy(ko.unwrap(_.get(datahub, group, [])), [sortingByAttr]), optionsBuilderFn);

        function buildOptionsFn(item, index) {
            var baseObj = {};
            _.set(baseObj, self.selectOptions.containerPathKey, item);
            _.set(baseObj, self.selectOptions.valueKey, index);
            return baseObj;
        }

        function updateOptionsFn(item, index) {
            return _.set(item, self.selectOptions.valueKey, index);
        }
    }

    function initializeLists() {
        var observableList;
        var updatedList;

        //  'all' is all (doh!) - without pagination
        observableList = _.get(self, ['lb', 'left', 'all']);
        updatedList = getOptionsReadyArray(self.originalDatasets, 'left', 'initialize');
        if (_.isNil(observableList)) {
            _.set(self, ['lb', 'left', 'all'], ko.observableArray(updatedList));
        } else {
            observableList(updatedList);
        }

        observableList = _.get(self, ['lb', 'right', 'all']);
        updatedList = getOptionsReadyArray(self.originalDatasets, 'right', 'initialize');
        if (_.isNil(observableList)) {
            _.set(self, ['lb', 'right', 'all'], ko.observableArray(updatedList));
        } else {
            observableList(updatedList);
        }

        updateElements();
    }

    function initializeVariables() {
        self.params = params;

        self.selectOptions = {};
        _.set(self.selectOptions, 'containerPathKey', 'obj');
        _.set(self.selectOptions, 'textKey', _.get(params, 'optionsText', 'name'));
        _.set(self.selectOptions, 'valueKey', _.get(params, 'optionsValue', 'id'));

        self.originalDatasets = {};
        _.set(self.originalDatasets, 'lb', ko.observableArray());
        _.set(self.originalDatasets, 'left', ko.observableArray());
        _.set(self.originalDatasets, 'right', ko.observableArray());

        self.itemPluralName = _.get(params, 'itemPluralName', 'Items');

        let pgLeft = getInitializedPaginator('left');
        _.set(self, ['pg', 'left'], pgLeft);

        let pgRight = getInitializedPaginator('right');
        _.set(self, ['pg', 'right'], pgRight);

        return Promise.resolve();
    }

    function mergeArrays(action, scope) {
        var handlers = {
            add: {
                all: handleMergeProvider(['right', 'all'], ['left', 'all']),
                page: handleMergeProvider(['right', 'all'], ['left', 'page']),
                selection: handleMergeProvider(['right', 'all'], ['left', 'selection'])
            },
            remove: {
                all: handleMergeProvider(['left', 'all'], ['right', 'all']),
                page: handleMergeProvider(['left', 'all'], ['right', 'page']),
                selection: handleMergeProvider(['left', 'all'], ['right', 'selection'])
            }
        };

        return _.get(handlers, [action, scope], _.noop);

        function handleMergeProvider(moveIn, moveOut) {
            return function handleMerge() {
                var allPagesButCurrent;
                var partialMoveOutSnapshotArray;

                var moveInSnapshotArray = getArraySnapshot(moveIn);
                var moveOutSnapshotArray = getArraySnapshot(moveOut);

                var group = _.first(moveOut);
                var scope = _.last(moveOut);

                if (scope !== 'all') {
                    var moveOutPaginator = _.get(self, ['pg', group]);
                    allPagesButCurrent = moveOutPaginator.getAllPagesButCurrent();

                    partialMoveOutSnapshotArray = getArraySnapshot([].concat(group, 'page'));
                    if (scope === 'selection') {
                        var offset = _.get(partialMoveOutSnapshotArray, [0, self.selectOptions.valueKey], 0);
                        moveOutSnapshotArray = _.map(moveOutSnapshotArray, function (selectedIndex) {
                            return selectedIndex - offset;
                        });
                        moveOutSnapshotArray = _.pullAt(partialMoveOutSnapshotArray, moveOutSnapshotArray);
                    } else {
                        partialMoveOutSnapshotArray = [];
                    }

                } else {
                    allPagesButCurrent = [];
                    partialMoveOutSnapshotArray = [];
                }

                var newMoveInArray = [].concat(moveOutSnapshotArray, moveInSnapshotArray);
                var newMoveOutArray = [].concat(partialMoveOutSnapshotArray, allPagesButCurrent);

                _.get(self.originalDatasets, _.first(moveIn))(newMoveInArray);
                _.get(self.originalDatasets, group)(newMoveOutArray);
                updateLists();
            };

            function getArraySnapshot(path) {
                //  'lb' stands for 'list builder' (pseudo namespace)
                return ko.unwrap(_.get(self, ['lb'].concat(path)));
            }
        }
    }

    function setupWidget() {
        //  'lb' stands for 'list builder' (pseudo namespace)

        //  setup 'add' (buttons) handlers: all, page & selection
        _.set(self, ['lb', 'add', 'all', 'clickHandler'], mergeArrays('add', 'all'));
        _.set(self, ['lb', 'add', 'page', 'clickHandler'], mergeArrays('add', 'page'));
        _.set(self, ['lb', 'add', 'selection', 'clickHandler'], mergeArrays('add', 'selection'));

        //  setup 'remove' (buttons) handlers: all, page & selection
        _.set(self, ['lb', 'remove', 'all', 'clickHandler'], mergeArrays('remove', 'all'));
        _.set(self, ['lb', 'remove', 'page', 'clickHandler'], mergeArrays('remove', 'page'));
        _.set(self, ['lb', 'remove', 'selection', 'clickHandler'], mergeArrays('remove', 'selection'));

        self.getOptionsText = getObjectValueByAccessorProvider(
            self.selectOptions.containerPathKey + '.' + self.selectOptions.textKey
        );
        self.getOptionsValue = getObjectValueByAccessorProvider(self.selectOptions.valueKey);

        return null;

        function getObjectValueByAccessorProvider(accessor) {
            return function getObjectValue(item) {
                return _.replace(_.get(item, accessor), /['"]/, '');
            };
        }
    }

    function updateElements(pagesObj) {
        //  TODO: consider a simpler approach
        updatePagination();
        updateListBuilder();

        function updateListBuilder() {
            let pgLeft =  _.get(self, ['pg', 'left'], pgLeft);

            let pgRight = _.get(self, ['pg', 'right'], pgRight);
            //  'lb' stands for 'list builder' (pseudo namespace)

            //  initial left select items
            _.set(self, ['lb', 'left', 'page'], ko.computed(pgLeft.getCurrentPage(), self));
            //  initial right select items
            _.set(self, ['lb', 'right', 'page'], ko.computed(pgRight.getCurrentPage(), self));

            //  represent user-selection items (to be moved to the other corresponding set using a button)
            //  (e.g.: 'right.selection' are items selection from 'right.page' that can be moved
            //    to 'left.page' via click on '< Remove' button).
            _.set(self, ['lb', 'left', 'selection'], getInitializedSelection('left'));
            _.set(self, ['lb', 'right', 'selection'], getInitializedSelection('right'));

            function getInitializedSelection(group) {
                var selection = _.get(self, ['lb', group, 'selection']);
                if (_.isNil(selection)) {
                    selection = ko.observableArray();
                } else {
                    selection([]);
                }
                return selection;
            }
        }

        function updatePagination() {
            //  'pg' stands for 'pagination' (pseudo namespace)

            //  divide all into pages
            let pgLeft = getInitializedPaginator('left');
            _.set(self, ['pg', 'left'], pgLeft);

            let pgRight = getInitializedPaginator('right');
            _.set(self, ['pg', 'right'], pgRight);
        }
    }

    function getInitializedPaginator(group) {
        var dataset = ko.unwrap(_.get(self, ['lb', group, 'all'], []));
        var pg = _.get(self, ['pg', group], null);
        if (_.isNil(pg)) {
            pg = new Pagination(dataset);
        } else {
            pg.update(dataset, _.get(getCurrentPages(), group));
        }
        return pg;
    }

    function updateIOParams() {
        _.get(self, 'params.updatedAvailableItems')(_.map(ko.unwrap(_.get(self, ['lb', 'left', 'all'])), getIdsFromItems));
        _.get(self, 'params.updatedSelectedItems')(_.map(ko.unwrap(_.get(self, ['lb', 'right', 'all'])), getIdsFromItems));

        function getIdsFromItems(item) {
            return _.get(item, self.selectOptions.containerPathKey, null);
        }
    }

    function updateLists() {
        var pagesObj = getCurrentPages();

        //  "hack" to force UI update  ¬¬
        clearUI();

        //  'all' is all (doh!) - without pagination
        _.get(self, ['lb', 'left', 'all'])(getOptionsReadyArray(self.originalDatasets, 'left', 'update'));
        _.get(self, ['lb', 'right', 'all'])(getOptionsReadyArray(self.originalDatasets, 'right', 'update'));
        updateIOParams();
        updateElements(pagesObj);
    }

    function getCurrentPages() {
        var pages = {};
        var groups = ['left', 'right'];
        _.forEach(groups, function (group) {
            var paginator = _.get(self, ['pg', group]);
            _.set(pages, group, !_.isNil(paginator) ? paginator.getCurrentPageNumber() : 1);
        });
        return pages;
    }
}

function Pagination(items) {
    var self = this;

    var maxPagesToDisplay = 5;
    var pageSize = 20;

    activate(items);

    self.getAllPagesButCurrent = function () {
        var currentPageIndex = getPageIndex(self.pageNumber);
        return _.chain(self.pages)
            .filter(function (page, index) {
                return (index !== currentPageIndex);
            })
            .flatMap()
            .value();
    };

    self.getCurrentPage = function () {
        return function getCurrentPage() {
            return ko.unwrap(_.get(self, 'currentPage'));
        };
    };

    self.getCurrentPageNumber = function () {
        return self.pageNumber;
    };

    self.update = update;

    function activate(allItems) {
        var pageNumber = 1;
        _.extend(self, {
            //  actual page (with items inside)
            currentPage: ko.observableArray(),
            goToPage: goToPage,
            isVisible: ko.observable(),
            //  current page number
            pageNumber: pageNumber,
            //  number of pages
            pagesCount: ko.observable(),
            pagesLinks: ko.observableArray()
        });
        update(allItems, pageNumber);
        return self;
    }

    function getPageIndex(pageNumber) {
        var pageIndex = pageNumber - 1;
        var lastIndex = self.pagesCount() - 1;
        if (pageIndex > lastIndex) {
            pageIndex = lastIndex;
        }
        if (pageIndex < 0) {
            pageIndex = 0;
        }
        return pageIndex;
    }

    function getPages(allItems) {
        //  TODO: consider a cheaper approach (pageMinIdx, pageMaxIdx)
        return _.chunk(allItems, pageSize);
    }

    function getPagesLink(currentPage) {
        var maxPages = (maxPagesToDisplay % 2) ? (maxPagesToDisplay - 1) : maxPagesToDisplay;
        var pagesCount = self.pages.length;

        return buildLinks(getLeftPages(), getRightPages());

        function buildLinks(leftEnd, rightEnd) {
            var baseStatus = 'fake-link';
            var leftCount = 0;
            var rightCount = 0;
            var directionFlag = 'left';
            var pages = [{ label: currentPage, status: 'active' }];

            //  TODO: consider a cheaper approach
            while (leftCount + rightCount < maxPages) {
                if (directionFlag === 'left') {
                    if (!_.isEmpty(leftEnd)) {
                        pages = [].concat({ label: leftEnd.pop(), status: baseStatus }, pages);
                    } else if (!_.isEmpty(rightEnd)) {
                        rightCount--;
                    }
                    leftCount++;
                    directionFlag = 'right';

                } else if (directionFlag === 'right') {
                    if (!_.isEmpty(rightEnd)) {
                        pages = [].concat(pages, { label: rightEnd.shift(), status: baseStatus });
                    } else if (!_.isEmpty(leftEnd)) {
                        leftCount--;
                    }
                    rightCount++;
                    directionFlag = 'left';
                }
            }

            var firstPageLabel = _.get(_.first(pages), 'label');
            if (firstPageLabel !== 1) {
                if (firstPageLabel !== 2) {
                    pages = [].concat({ label: '...' }, pages);
                }
                pages = [].concat({ label: 1, status: baseStatus }, pages);
            }

            var lastPageLabel = _.get(_.last(pages), 'label');
            if (lastPageLabel !== pagesCount) {
                if (lastPageLabel !== pagesCount - 1) {
                    pages = [].concat(pages, { label: '...' });
                }
                pages = [].concat(pages, { label: pagesCount, status: baseStatus });
            }

            return pages;
        }

        function getLeftPages() {
            return _
                .chain(_.times(maxPages))
                .map(function (n) {
                    return currentPage - maxPages + n;
                })
                .filter(function (n) {
                    return n >= 1;
                })
                .value();
        }

        function getRightPages() {
            return _
                .chain(_.times(maxPages))
                .map(function (n) {
                    return currentPage + 1 + n;
                })
                .filter(function (n) {
                    return n <= pagesCount;
                })
                .value();
        }
    }

    function goToPage(page) {
        var pageNumber = _.toInteger(page.label);
        if (_.isInteger(pageNumber)) {
            paginate(pageNumber);
        }
    }

    function paginate(pageNumber) {
        var pageIndex = getPageIndex(pageNumber || _.get(self, 'pageNumber', 1));
        self.pageNumber = pageIndex + 1;
        self.pagesLinks(getPagesLink(self.pageNumber));
        return self.currentPage(_.get(self, ['pages', pageIndex], []));
    }

    function update(allItems, newPage) {
        var pagesCount;
        self.pages = getPages(allItems);
        pagesCount = self.pages.length;
        self.pagesCount(pagesCount);
        self.isVisible(!_.isEmpty(allItems) && pagesCount > 1);
        paginate(newPage);
    }
}

// This runs when the component is turn down. Put here any logic necessary to clean up,
// for example cancelling timers or disposing ko subscriptions or computed properties.
ListBuilderWidget.prototype.dispose = function () {};

export default { template: templateMarkup, viewModel: ListBuilderWidget };
